import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './features.css'

const SmallBlock = ({ title, text, children }) => (
  <div styleName="block-small">
    <div styleName="title">{title}</div>
    <div styleName="text">{text}</div>

    <div styleName="block__children">{children}</div>
  </div>
)

SmallBlock.propTypes = {
  children: PropTypes.any,
  text: PropTypes.string,
  title: PropTypes.string,
}

export default CSSModules(SmallBlock, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/features/small-block.js
 **/